import { each } from 'lodash';
import {
  QUESTION_MATRIX_OPEN_ENDED_STYLES,
  QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES,
  QUESTION_MATRIX_OPEN_ENDED_CLASSES,
  QUESTION_MATRIX_OPEN_ENDED_TEXTAREA_ROWS,
  QUESTION_MATRIX_OPEN_ENDED_TEXTAREA_ROWS_MOBILE,
  ROW_LABEL_SELECTOR,
} from './constants';

// Expand and collapse a row when needed
export function toggleQuestionCollapse(element) {
  const target = $(element).closest(`.${ROW_LABEL_SELECTOR}`);
  const answersDiv = $(target).siblings(
    '.answer--matrix-open-ended-content-wrapper',
  );
  if (target.hasClass(`${ROW_LABEL_SELECTOR}--closed`)) {
    answersDiv.slideDown();
    target.removeClass(`${ROW_LABEL_SELECTOR}--closed`);
  } else {
    answersDiv.slideUp();
    target.addClass(`${ROW_LABEL_SELECTOR}--closed`);
  }
}

export function onScrollDownMessage() {
  let hasEmptyAnswer = false;
  each($('.answer--matrix-open-ended-answer-input'), (answerElement) => {
    if (
      $(answerElement).attr('data-input-required') === 'true' &&
      $(answerElement).val() === ''
    ) {
      hasEmptyAnswer = true;
    }
  });

  if (
    !hasEmptyAnswer &&
    !$('[data-btn="submit-btn"]').isOnScreen() &&
    Pollfish.helper.flag.showScrollDownMsg
  ) {
    Pollfish.helper.flag.showScrollDownMsg = false;
    Pollfish.ui.prompt(Pollfish.ui.getText('scroll_down'));
  }
}

export function getRowClass(appearance) {
  if (appearance === QUESTION_MATRIX_OPEN_ENDED_STYLES.VERTICAL) {
    return 'answer--matrix-open-ended-vertical';
  }
  return 'answer--matrix-open-ended-horizontal';
}

export function getInputClass(size, appearance) {
  let inputSize = QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES[size];

  if (appearance === QUESTION_MATRIX_OPEN_ENDED_STYLES.VERTICAL || !inputSize) {
    inputSize = QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES.FULL_WIDTH;
  }

  return `answer--matrix-open-ended-answer-input-${QUESTION_MATRIX_OPEN_ENDED_CLASSES[inputSize]}`;
}

function getContainerClass(appearance) {
  let containerClasses = 'answer--matrix-open-ended-answer-container';

  if (appearance === QUESTION_MATRIX_OPEN_ENDED_STYLES.VERTICAL) {
    containerClasses += ' answer--matrix-open-ended-answer-container-vertical';
  }

  return containerClasses;
}

export function getStyles(size, appearance) {
  return {
    answerStyle: getRowClass(appearance),
    inputStyle: getInputClass(size, appearance),
    containerClasses: getContainerClass(appearance),
  };
}

export function isMobileMediaQuery() {
  // Use the same media query breakpoint(s) as your CSS
  return window.matchMedia('(max-width: 600px)').matches;
}

export function getNumberOfRowsForTextOpenEnded(inputSize) {
  const size =
    QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES[inputSize] ||
    QUESTION_MATRIX_OPEN_ENDED_INPUT_SIZES.FULL_WIDTH;

  if (isMobileMediaQuery()) {
    return QUESTION_MATRIX_OPEN_ENDED_TEXTAREA_ROWS_MOBILE[size];
  }

  return QUESTION_MATRIX_OPEN_ENDED_TEXTAREA_ROWS[size];
}
